import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

interface RadarChartProps {
  titulo?: string;
  cor?: string[];
  series: any;
  categories: any;
}
const RadarChart: React.FC<RadarChartProps> = (props) => {
  const { titulo, cor, series, categories } = props;
  const [hack, setHack] = useState<string>("");

  const breakpoint = useBreakpoint();
  useEffect(() => {
    setTimeout(() => {
      //small screen o gráfico fica perdido, assim forçamos ele a recalcular os tamanhos
      setHack("hack");
    }, 1000);
  }, []);

  const options: ApexOptions = {
    chart: {
      background: "none",
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: "none",
    },
    title: {
      text: titulo,
      style: {
        color: "white",
      },
    },
    plotOptions: {
      radar: {
        size: breakpoint.xxl ? 250 : breakpoint.lg ? 180 : 40,
        polygons: {
          strokeColors: ["white"],
          fill: {
            colors: ["transparent", "transparent"],
          },
        },
      },
    },
    yaxis: {
      forceNiceScale: true,
      show: false,
      axisTicks: { show: true, width: 6 },
      labels: {
        style: {
          fontSize: "16px",
        },
      },
    },
    colors: cor,
    xaxis: {
      categories,
      min: 0,
      max: 1,
      labels: {
        style: {
          fontSize: breakpoint.md ? "18px" : "10px",
          colors: categories.map(() => "white"),
        },
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      fontSize: "16px",
      labels: {
        colors: "white",
      },
    },
  };

  return (
    <div className={hack}>
      <Chart series={series} options={options} type="radar" />
    </div>
  );
};

export default RadarChart;
